module.exports = __webpack_public_path__ + "img/about4.86391ba5.png";